import { matchRoutes, useLocation, useParams } from "react-router-dom";
import { routerData } from "../config/RoutesConfig";

const replaceParams = (path, params) => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    return acc.replace(new RegExp(`:${key}\\b`, "g"), value);
  }, path);
};

const useFindRoute = () => {
  const routes = routerData();
  const location = useLocation();
  const params = useParams();
  const matched = matchRoutes(routes, location);
  const pattern = matched?.[0]?.route?.path;

  // USAGE of this replaceParams function process ============>
  //   const path = replaceParams("/:lang/user/organization/settings/:orgId", {
  //     lang: "en",
  //     orgId: "organization-MetHU_NfuU",
  //   });

  return { matchedRoute: pattern, ...location, ...params, replaceParams };
};

export default useFindRoute;
